import PortfolioSummaryContainer from 'containers/PortfolioSummary'
import React, { FC } from 'react'

const PortfolioSummaryPage: FC = () => <PortfolioSummaryContainer />

export default PortfolioSummaryPage
